
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[[...route]]",
      function () {
        return require("private-next-pages/s/[[...route]]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[[...route]]"])
      });
    }
  